var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeligram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3239 50.6679C41.3151 50.6679 51.0358 40.9471 51.0358 28.956C51.0358 16.9649 41.3151 7.24414 29.3239 7.24414C17.3328 7.24414 7.61206 16.9649 7.61206 28.956C7.61206 40.9471 17.3328 50.6679 29.3239 50.6679Z",
    fill: "url(#paint0_linear_344_5400)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3434 38.9073C24.64 38.9073 24.7595 38.6417 24.5169 37.972L22.4485 31.1645L38.3705 21.7188",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3434 38.9073C25.8862 38.9073 26.126 38.6591 26.429 38.3645L29.3239 35.5496L25.7128 33.3721",
    fill: "#A9C9DD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7125 33.3729L34.4624 39.8374C35.4608 40.3883 36.1815 40.1031 36.4302 38.9104L39.9918 22.1266C40.3565 20.6646 39.4346 20.0015 38.4794 20.4352L17.5654 28.4995C16.1378 29.0721 16.1462 29.8686 17.3052 30.2235L22.6722 31.8986L35.0973 24.0597C35.6839 23.704 36.2222 23.8952 35.7804 24.2874",
    fill: "url(#paint1_linear_344_5400)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_5400",
    x1: 36.5627,
    y1: 14.4829,
    x2: 25.7067,
    y2: 39.8119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_344_5400",
    x1: 32.0388,
    y1: 28.9561,
    x2: 35.4365,
    y2: 36.6879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeligram);
export default __webpack_public_path__ + "static/media/teligram.cd1eb6ca63af3185e4af2974678117c8.svg";
export { ForwardRef as ReactComponent };